import {eachYearOfInterval} from 'date-fns';

interface GenerateYearsBetweenProps {
	startYear: number;
	endYear?: number;
	reverse?: boolean;
}

export function generateYearsBetween({
	startYear,
	endYear,
	reverse = true,
}: GenerateYearsBetweenProps): string[] {
	if (typeof startYear !== 'number' || (endYear && typeof endYear !== 'number')) {
		return [];
	}

	const years = eachYearOfInterval({
		start: new Date(startYear, 0),
		end: new Date(endYear || new Date().getFullYear(), 0),
	});

	const formattedYears = years.map(year => year.getFullYear().toString());

	if (reverse) {
		const yearsInDescendingOrder = [...formattedYears].reverse();
		return yearsInDescendingOrder;
	}
	return formattedYears;
}
